import { render, staticRenderFns } from "./RiwayatPendidikan.vue?vue&type=template&id=4b008d83&"
import script from "./RiwayatPendidikan.vue?vue&type=script&lang=js&"
export * from "./RiwayatPendidikan.vue?vue&type=script&lang=js&"
import style0 from "./RiwayatPendidikan.vue?vue&type=style&index=0&id=4b008d83&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports